import { render, staticRenderFns } from "./CartaoInformacoes.vue?vue&type=template&id=f799aca4&scoped=true"
import script from "./CartaoInformacoes.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoes.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoes.vue?vue&type=style&index=0&id=f799aca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f799aca4",
  null
  
)

export default component.exports